import NewFondationsApiModel from 'models/global/NewFondationsApiModel';

export default class EntityIdModel extends NewFondationsApiModel {
	static get path(): string {
		return '/entities/ids/{?id}';
	}
}
